import { reviewerInvite } from '@/api/reviewer'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { DECISION_STATUS } from '@/utils/dict'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      showEditor: true,
      showAuthor: true,
      // isEditor: false,
      isView: true,
      responseData: [],
      decisionStatus: DECISION_STATUS,
      showReport: true,
      showResponse: true
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      title: 'getTitle',
      domain: 'getDomain'
    })
  },
  mounted() {
    // this.isEditor = this.$route.path.includes('editorial-office')
    this.getData()
  },
  methods: {
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(this.responseData.fileList, 'author_files.zip')
      }
    },
    async getData() {
      const parmas = this.$route.params
      let id = parmas.id

      const result = await reviewerInvite.report(id)
      this.responseData = result
    },
    back() {
      // this.$router.push('/reviewers-menu/reviews')
      this.$router.back(-1)
    },
    togalReport(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.responseData = JSON.parse(JSON.stringify(this.responseData))
    }
  }
}
